import React from 'react';

import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import PartsListWithCheckbox from '@/main/components/shared/partsListWithCheckbox/partsListWithCheckbox';

import { GetItemsByStatusResponse } from '@/main/models/response';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import * as S from './styles';
import ChangeStatusFileUpload from '../changeStatus/changeStatusFileUpload';
import { ChangeStatusItemsRequest } from '@/main/models/request';
import { useForm } from 'react-hook-form';
import KogInputTextControlledNew from '@/main/components/shared/inputText/inputTextControlledNew';

interface ITransitForm {
  shippingName: string;
  trackingCode: string;
}

interface IAssignedToInTransit {
  closeModal: () => void;
  options: GetItemsByStatusResponse[];
  optionsSelected: string[];
  setOptionsSelected: React.Dispatch<React.SetStateAction<string[]>>;
  files: File[];
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  handleSubmitChangeStatus(
    extraData?: Pick<
      ChangeStatusItemsRequest,
      'shippingName' | 'trackingCode'
    >
  ): void;
  loadingSubmit: boolean;
  loadingOptions: boolean;
}

function AssignedToInTransit({
  closeModal,
  options,
  optionsSelected,
  setOptionsSelected,
  files,
  setFiles,
  handleSubmitChangeStatus,
  loadingSubmit,
  loadingOptions
}: IAssignedToInTransit) {
  const INITIAL_FORM_STATE = {
    shippingName: '',
    trackingCode: ''
  };

  const {
    control,
    handleSubmit,
    setError,
    clearErrors,
    setValue,
    watch
  } = useForm<ITransitForm>({
    mode: 'all',
    defaultValues: INITIAL_FORM_STATE
  });

  function onSubmit(data: ITransitForm) {
    if (isShippingMandatory) {

      let hasError = false;

      if (data.shippingName.trim() === '') {
        setError('shippingName', { type: 'required' });
        hasError = true;
      }

      if (data.trackingCode.trim() === '') {
        setError('trackingCode', { type: 'required' });
        hasError = true;
      }

      if (hasError) return;
    }

    handleSubmitChangeStatus({ ...data });
  }

  const isShippingMandatory = options.some(x => x.isMandatoryShippingInformation);
  const MAX_LENGTH = 20;

  return (
    <>
      <S.Content>
        <PartsListWithCheckbox
          parts={options}
          optionsSelected={optionsSelected}
          setOptionsSelected={setOptionsSelected}
          isLoading={loadingOptions}
        />

      </S.Content>

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <S.Content>
          <KogInputTextControlledNew
            control={control}
            name="shippingName"
            required={isShippingMandatory}
            label={getTranslateByKey('information.deliveryService')}
            inputProps={{ maxLength: MAX_LENGTH }}
            id="id-assignedToInTransit-input-shippingName"
          />

          <KogInputTextControlledNew
            control={control}
            name="trackingCode"
            required={isShippingMandatory}
            label={getTranslateByKey('information.trackingCode')}
            inputProps={{ maxLength: MAX_LENGTH }}
            id="id-assignedToInTransit-input-trackingCode"
          />
        </S.Content>
        <ChangeStatusFileUpload files={files} setFiles={setFiles} />
        <S.ContainerButton>
          <SecondaryButton onClick={closeModal} id="id-assignedToInTransit-button-back">
            {getTranslateByKey('information.back')}
          </SecondaryButton>
          <SecondaryButton
            disabled={optionsSelected.length == 0 || loadingSubmit}
            type="submit"
            isLoading={loadingSubmit}
            id="id-assignedToInTransit-button-submit">
            {getTranslateByKey('information.send')}
          </SecondaryButton>
        </S.ContainerButton>
      </form>
    </>
  );
}

export default AssignedToInTransit;
